"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LayoutFill = {
  name: 'layout',
  theme: 'fill',
  nameWithTheme: 'layout-fill',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z'
    },
    children: []
  }]
};
exports.default = LayoutFill;